module.exports = __webpack_public_path__ + "media/packs/images/flags/PR-8794772df7261387dcc268e5ba1091b8.png";